(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialize = (scope = document) => {
    scope.querySelectorAll('.barbara-editorial-footer').forEach((footer) => {
      [...footer.children].slice(1).forEach((group, index) => {
        if (group.dataset.footerDisclosure) return;
        const holder = group.querySelector('.group-block-content');
        const heading = holder?.querySelector('h2');
        if (!heading) return;
        const title = heading.textContent.trim();
        const panel = document.createElement('div');
        panel.className = 'barbara-footer-panel';
        panel.id = footer.closest('[id]')?.id + '-footer-panel-' + index;
        const label = document.createElement('span');
        label.className = 'barbara-footer-heading-label';
        label.textContent = title;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'barbara-footer-toggle';
        button.textContent = title;
        button.setAttribute('aria-controls', panel.id);
        heading.remove();
        panel.append(...holder.childNodes);
        heading.replaceChildren(label, button);
        holder.replaceChildren(heading, panel);
        group.classList.add('barbara-footer-disclosure');
        group.dataset.footerDisclosure = 'true';
        let expanded = false;
        const update = () => {
          panel.hidden = mobile.matches && !expanded;
          button.setAttribute('aria-expanded', String(!panel.hidden));
          button.tabIndex = mobile.matches ? 0 : -1;
        };
        button.addEventListener('click', () => {
          expanded = !expanded;
          update();
        });
        mobile.addEventListener('change', update);
        update();
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
